export default __webpack_public_path__ + "45a4c84ea92f2499f1a0f7374fb26a58.svg";